import { defaultWidgetOptions } from "./posterWidgetOptions";

function newBlockId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `b-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/** Convierte bloques iframe antiguos a widgets de datos. */
export function migrateLegacyBlocks(layout) {
  if (!layout?.blocks) return layout;
  return {
    ...layout,
    blocks: layout.blocks.map((b) => {
      if (b.type === "iframe") {
        const next = { ...b, type: "widget", widgetKind: b.iframeMode || "groups" };
        delete next.iframeMode;
        return next;
      }
      return b;
    }),
  };
}

/**
 * Plantilla inicial pensada como cartel ancho tipo "tablero de día":
 *   - cabecera arriba a todo ancho
 *   - Grupos en horizontal (lado a lado)
 *   - Cuadro horario (matriz hora × campo) ocupando el ancho completo, que es
 *     la vista por defecto más útil para un cartel de jornada
 *   - Bracket abajo con layout "rounds" (Octavos / Cuartos / Semifinal / Final)
 *   - QR pequeño en una esquina
 */
export function createDefaultCanvasLayout() {
  return {
    v: 1,
    w: 1600,
    h: 2200,
    blocks: [
      { id: newBlockId(), type: "header", x: 40, y: 32, w: 1520, h: 110, z: 1 },
      {
        id: newBlockId(),
        type: "widget",
        x: 40,
        y: 168,
        w: 1520,
        h: 360,
        z: 2,
        widgetKind: "groups",
        widgetFlow: "horizontal",
        widgetOptions: defaultWidgetOptions("groups"),
      },
      {
        id: newBlockId(),
        type: "widget",
        x: 40,
        y: 552,
        w: 1520,
        h: 760,
        z: 2,
        widgetKind: "schedule",
        widgetOptions: defaultWidgetOptions("schedule"),
      },
      {
        id: newBlockId(),
        type: "widget",
        x: 40,
        y: 1336,
        w: 1280,
        h: 520,
        z: 2,
        widgetKind: "bracket",
        widgetFlow: "horizontal",
        widgetOptions: defaultWidgetOptions("bracket"),
      },
      { id: newBlockId(), type: "qr", x: 1340, y: 1336, w: 220, h: 220, z: 3 },
    ],
  };
}

/**
 * Lienzo casi vacío (solo cabecera) para empezar un cartel desde cero, sin las
 * tablas de la plantilla por defecto.
 */
export function createBlankCanvasLayout() {
  return {
    v: 1,
    w: 1600,
    h: 2200,
    blocks: [
      { id: newBlockId(), type: "header", x: 40, y: 32, w: 1520, h: 110, z: 1 },
    ],
  };
}

export function parseCanvasLayoutJson(json) {
  if (!json || typeof json !== "string") return null;
  try {
    const o = JSON.parse(json);
    if (o && o.v === 1 && typeof o.w === "number" && typeof o.h === "number" && Array.isArray(o.blocks)) {
      return clampLayout(migrateLegacyBlocks(o));
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clampLayout(layout) {
  if (!layout || layout.v !== 1) return createDefaultCanvasLayout();
  const w = Math.min(2400, Math.max(320, Number(layout.w) || 1200));
  const h = Math.min(8000, Math.max(400, Number(layout.h) || 2200));
  return migrateLegacyBlocks({
    v: 1,
    w,
    h,
    blocks: Array.isArray(layout.blocks) ? layout.blocks : [],
  });
}

export { newBlockId };
